module.exports = require("https");


//////////////////
// WEBPACK FOOTER
// external "https"
// module id = 165
// module chunks = 0